import { BuilderContent } from '@builder.io/sdk';
import { GenericDynamicComponent } from '../../classes/DynamicComponent';
import { PAGE_COMPONENT_TYPES, PAGE_LAYOUT_TYPES, ValueOf } from './to-pandora-index';
import { HeroBannerPageComponentType } from './hero-banner';

// Global constants for Builder.io page components
export const CUSTOM_PAGE_LAYOUT_TYPES = {
  BEST_OFFERS: 'best-offer',
  CONTENTFUL_PAGE: 'contentful-page',
} as const;

// Type definitions
export type DefaultPageComponentType = ValueOf<typeof PAGE_COMPONENT_TYPES>;
export type PageLayoutType = ValueOf<typeof PAGE_LAYOUT_TYPES & typeof CUSTOM_PAGE_LAYOUT_TYPES>;

// Interfaces
export interface BuilderComponentConfig {
  tag: string;
  name: string;
  inputs: any[];
}

export interface BuilderComponent {
  config: BuilderComponentConfig;
  target: any;
}

export interface ProductSpecificCampaign {
  active: boolean;
  name: string;
  code?: string;
  textHighlight?: string;
  startDate?: string;
  endDate?: string;
  products: string[];
}

export interface PageLayoutComponent {
  id: PageLayoutType;
}

export interface BuilderPageComponent {
  id: DefaultPageComponentType | HeroBannerPageComponentType;
}

export interface PageComponentService<T = BuilderPageComponent | PageLayoutComponent> {
  getComponent(id: string, component?: T): Promise<GenericDynamicComponent | undefined>;
}

export interface BuilderPageData {
  page: {
    value: BuilderContent;
  };
  serverNavigation?: boolean;
}

export interface BuilderPageResultData {
  data: BuilderPageData;
}
export interface BuilderPageResults {
  results: { data: BuilderPageData }[];
}

export interface BuilderContentResults {
  results: BuilderContent[];
}

// Type guards
export function isPageLayoutType(id: string): id is PageLayoutType {
  return [...Object.values(PAGE_LAYOUT_TYPES), ...Object.values(CUSTOM_PAGE_LAYOUT_TYPES)].includes(id as PageLayoutType);
}
